



export default class Helper {

    static measureString(hours){
        let finalString = `${hours}`
        let color = '';

        //handle week month year
        if (hours > 24){
            let days = hours / 24
            finalString = `${parseInt(days)} დღე`

            if (days > 365){
                let years = days / 364
                finalString = `${parseInt(years)} წელი`
            }
        }
        //handle hours
        else if (hours <= 24 && hours >= 1){
            hours = Math.floor(hours)
            finalString = ` ${hours} სთ`
        }
        //handle minutes
        else if(hours <= 1 && hours >= 0.1){
            finalString = ` ${(hours * 60).toFixed(0)} წთ`
        }
        //handle seconds
        else if(hours <= 0.1){
            finalString = ` 1 წთ`
        }

        if (hours > 6) {
            color = 'text-danger'
        }

        return {finalString,color}
    }



}
